import { Box, Flex, Switch } from "@chakra-ui/react";
import { Col, Row } from "antd";
import useSaveTenant from "core/features/tenants/hooks/useSaveTenant";
import {
  TenantDetalhe,
  TenantStatus,
} from "core/features/tenants/typings/tenant";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

// import DadosDeEndereco from "./DadosDeEndereco";
import DadosDeTributacao from "./DadosDeTributacao";
import DadosGerais from "./DadosGerais";
import { showErrorAxios, showSuccess } from "infra/helpers/alerta";
import DefaultButton from "ui/components/Button/PrimaryButton";
import Field from "ui/components/Input/Field";
import DadosDeEstrutura from "./DadosDeEstrutura";
import moment from "moment";
import { TipoTenantEnum } from "core/resources/enums/tenant";
import CardDefault from "ui/components/Cards/CardDefault";
import DadosDeEndereco from "ui/components/FormEndereco";
import { PessoaTipo } from "features/pessoas/typings";

interface DadosCadastraisProps {
  onSubmitSuccess: (result: string) => any;
  tipoTenantId: TipoTenantEnum;
  tenantId?: string;
  defaultData?: TenantDetalhe;
  isEdit?: boolean;
}

function DadosCadastrais({
  onSubmitSuccess,
  tenantId,
  defaultData,
  isEdit,
  tipoTenantId,
}: DadosCadastraisProps) {
  const { mutate: handleSave, isLoading } = useSaveTenant(tenantId);

  const [jaBuscou, setJaBuscou] = useState(isEdit);

  const { control, watch, handleSubmit, setValue, trigger, reset } =
    useForm<TenantDetalhe>({
      reValidateMode: "onChange",
      mode: "onChange",
      defaultValues: {
        statusId: TenantStatus.Ativo,
        tipoTenantId: TipoTenantEnum.Condominio,
        pessoaTipo: PessoaTipo.Juridica,
        dateCreated: moment().format("YYYY-MM-DD"),
        integradoPagamentoOnline: true,
        ...defaultData,
      },
    });

  const onSubmit = (data: TenantDetalhe) => {
    const formattedData: any = formatSubmitData(data);

    handleSave(formattedData, {
      onSuccess: ({ data }: any) => {
        showSuccess().then(() => {
          onSubmitSuccess(data.data);
        });
      },
      onError: (err) => {
        showErrorAxios(err);
      },
    });
  };

  const nome = watch("pessoa.nome");

  useEffect(() => {
    if (nome && !jaBuscou) {
      setJaBuscou(true);
    }
  }, [jaBuscou, nome]);

  useEffect(() => {
    if (defaultData?.id) {
      reset(defaultData);
    }
  }, [defaultData, reset]);

  const form = watch();

  const isPessoaFisica = form?.pessoaTipo === PessoaTipo.Fisica;

  return (
    <>
      <CardDefault>
        <form onSubmit={(ev) => handleSubmit(onSubmit)(ev)}>
          <DadosGerais
            forceEditDocument={true}
            watch={watch}
            setField={setValue}
            trigger={trigger}
            control={control}
            isEdit={isEdit}
            form={form}
          />

          {jaBuscou || isPessoaFisica ? (
            <>
              <Box fontSize="18px" my="32px">
                Informações de Endereço
              </Box>

              <DadosDeEndereco
                control={control}
                setField={setValue}
                watch={watch}
                shouldUnregister={false}
              />

              {!isPessoaFisica && tipoTenantId === TipoTenantEnum.Condominio ? (
                <Box fontSize="18px" my="32px">
                  Informações da Estrutura
                </Box>
              ) : null}

              {!isPessoaFisica && tipoTenantId === TipoTenantEnum.Condominio ? (
                <Box>
                  <DadosDeEstrutura control={control} />
                </Box>
              ) : null}

              {!isPessoaFisica ? (
                <Box fontSize="18px" my="32px">
                  Informações de Tributação
                </Box>
              ) : null}

              {!isPessoaFisica ? <DadosDeTributacao control={control} /> : null}

              <Box mb={6} mt="32px">
                <Row gutter={32}>
                  {/* <Col sm={8}>
                      <Field
                        label="Integrado com pagamento online?"
                        control={control}
                        name="integradoPagamentoOnline"
                        render={({ field }) => {
                          return (
                            <Switch
                              mt="8px"
                              isChecked={!!field.value}
                              onChange={() => {
                                field.onChange(!field.value);
                              }}
                            />
                          );
                        }}
                      />
                    </Col>
                */}

                  <Col sm={8}>
                    <Field
                      control={control}
                      label="Ativo?"
                      name="statusId"
                      render={({ field }) => {
                        const isChecked =
                          field.value?.toUpperCase() ===
                          TenantStatus.Ativo.toUpperCase();
                        return (
                          <Switch
                            isChecked={isChecked}
                            onChange={() => {
                              field.onChange(
                                !isChecked
                                  ? TenantStatus.Ativo
                                  : TenantStatus.Inativo
                              );
                            }}
                          />
                        );
                      }}
                    />
                  </Col>
                </Row>

                <Flex mt="16px" justifyContent={"flex-end"}>
                  <DefaultButton
                    type="submit"
                    isLoading={isLoading}
                    disabled={isLoading}
                  >
                    {isEdit ? "Salvar edição" : "Salvar"}
                  </DefaultButton>
                </Flex>
              </Box>
            </>
          ) : null}
        </form>
      </CardDefault>
    </>
  );
}

function formatSubmitData(data: TenantDetalhe) {
  const withFormattedStatus = { ...data, status: data.statusId };
  withFormattedStatus.pessoa.documento =
    withFormattedStatus.pessoa.documento.replace(/\D/g, "");
  return withFormattedStatus;
}

export default DadosCadastrais;
